var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8438 20.8359C19.8438 18.0961 16.29 15.875 11.9062 15.875C7.52249 15.875 3.96875 18.0961 3.96875 20.8359M11.9062 12.8984C9.1664 12.8984 6.94531 10.6774 6.94531 7.9375C6.94531 5.19765 9.1664 2.97656 11.9062 2.97656C14.6461 2.97656 16.8672 5.19765 16.8672 7.9375C16.8672 10.6774 14.6461 12.8984 11.9062 12.8984Z",
    stroke: "white",
    strokeWidth: 1.13393,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser02);
export default __webpack_public_path__ + "static/media/User_02.5f60690f0965ed1620b01b35db195989.svg";
export { ForwardRef as ReactComponent };